export default [
  // Auth Routes
  {
    path: '/403',
    name: '403',
    component: () => import('../views/pages/auth/403.vue'),
  },
  // Dashboard Home
  {
    path: '/',
    name: 'home',
    component: () => import('../views/pages/dashboard/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'dashboard' },
  },
  {
    path: '/device-dashboard',
    name: 'device_dashboard',
    component: () => import('../views/pages/dashboard/device.vue'),
    meta: { requiresAuth: true, requiredPermission: 'dashboard' },
  },
  {
    path: '/audit/logs',
    name: 'audit-logs',
    component: () => import('../views/pages/dashboard/audit_logs.vue'),
    meta: { requiresAuth: true, requiredPermission: 'system_admin_logs_audit' },
    props: true,
  },
  // Analytics Dashboard
  {
    path: '/analytics/dashboard/:deviceId',
    name: 'analytics-dashboard',
    component: () => import('../views/pages/analytics/dashboard.vue'),
    meta: { requiresAuth: true, requiredPermission: 'graphs' },
    props: true,
  },
  {
    path: '/analytics/dashboard/:deviceId/:componentname/:iface?',
    name: 'analytics-dashboard-component',
    component: () => import('../views/pages/analytics/dashboard-component.vue'),
    meta: { requiresAuth: true, requiredPermission: 'graphs' },
    props: true,
  },
  // Auth Routes
  {
    path: '/auth/login',
    name: 'login',
    component: () => import('../views/pages/auth/login.vue'),
  },
  {
    path: '/auth/recoverpwd',
    name: 'recover-pwd',
    component: () => import('../views/pages/auth/recoverpwd.vue'),
  },
  // Manage Users
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/pages/users/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'system_admin_accounts' },
  },
  {
    path: '/users/create',
    name: 'create-user',
    component: () => import('../views/pages/users/form.vue'),
    meta: {
      requiresAuth: true,
      requiredPermission: 'system_admin_accounts_add',
    },
  },
  {
    path: '/users/:id/edit',
    name: 'edit-user',
    component: () => import('../views/pages/users/form.vue'),
    meta: {
      requiresAuth: true,
      requiredPermission: 'system_admin_accounts_edit',
    },
  },
  // Manage Roles
  {
    path: '/roles',
    name: 'roles',
    component: () => import('../views/pages/roles/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'system_admin_roles' },
  },
  {
    path: '/roles/create',
    name: 'create-role',
    component: () => import('../views/pages/roles/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'system_admin_roles_add' },
  },
  {
    path: '/roles/:id/edit',
    name: 'edit-role',
    component: () => import('../views/pages/roles/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'system_admin_roles_edit' },
  },
  /* Device Management */
  // Credentials
  {
    path: '/credentials',
    name: 'credentials',
    component: () => import('../views/pages/credentials/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_credentials_list' },
  },
  {
    path: '/credentials/create',
    name: 'create-credential',
    component: () => import('../views/pages/credentials/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_credentials_add' },
  },
  {
    path: '/credentials/:id/edit',
    name: 'edit-credential',
    component: () => import('../views/pages/credentials/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_credentials_edit' },
  },
  // Categories
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/pages/categories/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_category_list' },
  },
  {
    path: '/categories/create',
    name: 'create-category',
    component: () => import('../views/pages/categories/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_category_add' },
  },
  {
    path: '/categories/:id/edit',
    name: 'edit-category',
    component: () => import('../views/pages/categories/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_category_edit' },
  },
  // Devices
  {
    path: '/devices',
    name: 'devices',
    component: () => import('../views/pages/devices/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'devices_list' },
    props: (route) => ({
      status: route.query.status,
      category: route.query.category,
      deviceType: route.query.deviceType,
    }),
  },
  {
    path: '/devices/create',
    name: 'create-device',
    component: () => import('../views/pages/devices/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'devices_add' },
  },
  {
    path: '/devices/create/bulk',
    name: 'create-device-bulk',
    component: () => import('../views/pages/devices/bulkForm.vue'),
    meta: { requiresAuth: true, requiredPermission: 'devices_add' },
  },
  {
    path: '/devices/update/bulk',
    name: 'update-device-bulk',
    component: () => import('../views/pages/devices/bulkUpdateForm.vue'),
    meta: { requiresAuth: true, requiredPermission: 'devices_edit' },
  },
  {
    path: '/devices/:id/edit',
    name: 'edit-device',
    component: () => import('../views/pages/devices/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'devices_edit' },
  },
  // Device Types
  {
    path: '/device/types',
    name: 'device-types',
    component: () => import('../views/pages/device_types/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_type_view' },
    props: true,
  },
  {
    path: '/device/types/:id/edit',
    name: 'edit-device-type',
    component: () => import('../views/pages/device_types/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_type_view' },
  },
  // Alerts
  {
    path: '/alerts/pending',
    name: 'pending-alerts',
    component: () => import('../views/pages/alerts/pending.vue'),
    meta: { requiresAuth: true, requiredPermission: 'pending_alerts_view' },
    props: (route) => ({
      host: route.query.host,
    }),
  },
  {
    path: '/alerts/cleared',
    name: 'cleared-alerts',
    component: () => import('../views/pages/alerts/cleared.vue'),
    meta: { requiresAuth: true, requiredPermission: 'cleared_alerts_view' },
  },
  {
    path: '/alerts/history',
    name: 'alerts-history',
    component: () => import('../views/pages/alerts/history.vue'),
    meta: { requiresAuth: true, requiredPermission: 'history_alerts_view' },
  },
  // Alert Rules
  {
    path: '/alert/rules',
    name: 'alert-rules',
    component: () => import('../views/pages/alert_rules/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'alert_rules' },
  },
  {
    path: '/alert/rules/create',
    name: 'create-alert-rule',
    component: () => import('../views/pages/alert_rules/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'alert_rules_add' },
  },
  {
    path: '/alert/rules/:id/edit',
    name: 'edit-alert-rule',
    component: () => import('../views/pages/alert_rules/form.vue'),
    meta: {
      requiresAuth: true,
      requiredPermission: 'alert_rules_edit',
    },
  },
  /* System Configuration */
  // Scheduled Maintenance
  {
    path: '/maintenance/schedules',
    name: 'maintenance-schedules',
    component: () => import('../views/pages/maintenance/index.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_maintenance_list' },
  },
  {
    path: '/maintenance/schedules/create',
    name: 'create-maintenance-schedule',
    component: () => import('../views/pages/maintenance/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'device_maintenance_add' },
  },
  {
    path: '/maintenance/schedules/:id/edit',
    name: 'edit-maintenance-schedule',
    component: () => import('../views/pages/maintenance/form.vue'),
    meta: {
      requiresAuth: true,
      requiredPermission: 'device_maintenance_edit',
    },
  },
  // Alerts Threshold
  // {
  //   path: '/alerts/threshold',
  //   name: 'alerts-threshold',
  //   component: () => import('../views/pages/alerts_threshold/index.vue'),
  //   meta: { requiresAuth: true, requiredPermission: 'alert_threshold' },
  // },
  // {
  //   path: '/alerts/threshold/create',
  //   name: 'create-alerts-threshold',
  //   component: () => import('../views/pages/alerts_threshold/form.vue'),
  //   meta: { requiresAuth: true, requiredPermission: 'alert_threshold' },
  // },
  // {
  //   path: '/alerts/threshold/:id/edit',
  //   name: 'edit-alerts-threshold',
  //   component: () => import('../views/pages/alerts_threshold/form.vue'),
  //   meta: {
  //     requiresAuth: true,
  //     requiredPermission: 'alert_threshold',
  //   },
  // },
  {
    path: '/alerts/threshold/:id',
    name: 'alerts-threshold',
    component: () => import('../views/pages/alerts_threshold/form.vue'),
    meta: { requiresAuth: true, requiredPermission: 'alert_threshold' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: () => import('../views/pages/auth/404.vue'),
  },
  {
    path: '/export-files',
    name: 'export-files',
    component: () => import('../views/pages/export_files/index.vue'),
    meta: { requiresAuth: true, authority: 'alert_exports' } 
  }
]
